import { Injectable } from '@angular/core';
import { CommonHttpService } from '../../shared/services/http.service';
import { Observable } from 'rxjs/Observable';
import { Response } from '@angular/http';
import { UnauthenticatedUserRepositoryService } from './unauthenticated-user-repository.service';

@Injectable()
export class PasswordRecoveryStepsService {
    constructor(
        protected http: CommonHttpService,
        protected unauthenticatedUserRepository: UnauthenticatedUserRepositoryService
    ) {}

    /**
     * Call API to trigger token to user.
     **/
    public triggerToken(type: number): Observable<null> {
        return new Observable(observable => {
            this.http.post(
                '/ecommerce/identification/password-recovery/token',
                {email: this.unauthenticatedUserRepository.getEmail(), type: type}
            ).subscribe((response: Response) => {
                if (response.status === 204) {
                    observable.next(null);
                    return observable.complete();
                }
                return observable.error('');
            }, () => {
                return observable.error('');
            });
        });
    }
    /**
     * Call API to validate inputted token from user.
     **/
    public validateToken(token: string, type: number): Observable<null> {
        return new Observable(observable => {
            this.http.get(
                '/ecommerce/identification/password-recovery/token' +
                `?email=${this.unauthenticatedUserRepository.getEmail()}` +
                `&token=${token}` +
                `&type=${type}`
            ).subscribe((response: Response) => {
                if (response.status === 204) {
                    observable.next(null);
                    return observable.complete();
                }
                return observable.error('');
            }, (err: Response) => {
                return observable.error(err.json());
            });
        });
    }
    /**
     * Call API to save new password to user from token.
     **/
    public savePassword(password: string, token: string): Observable<null> {
        return new Observable(observable => {
            this.http.post(
                '/ecommerce/identification/password-recovery',
                {password: password, token: token}
            ).subscribe((response: Response) => {
                if (response.status === 201) {
                    observable.next(null);
                    return observable.complete();
                }
                return observable.error('');
            }, () => {
                return observable.error('');
            });
        });
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3659550778/src/src/app/payment/services/password-recovery-steps.service.ts